import React from 'react';
import Dialogue from 'components/UI/Dialogue/Dialogue';

const UnsupportedImageDialogue = (props) => (
  <Dialogue
    subject="We're Sorry!"
    message="We only support JPEG & PNG image uploads at this point. Mind uploading a JPEG file instead?"
    confirm={props.clicked}
    confirmationText="Sure!"
  />
);

export default UnsupportedImageDialogue;
